import snsAxiosClient from '../common/http/http-sns';
import formatString from '../utils/formatString';

function updateCardStatus(environmentVariables, user) {
  const options = {
    headers: {
      ...environmentVariables.API_HEADERS_PATCH_V1,
      Authorization: `Bearer ${user.authToken}`,
    },
  };

  return snsAxiosClient(options).patch(
    formatString(environmentVariables.SNS_UPDATE_CARD_STATUS, {
      UUID: user.UUID,
    }),
    {
      uuid: user.UUID,
    },
  );
}

export default updateCardStatus;
